/**
 * Migration from the legacy 7-value reading / 6-value writing enums
 * (2026-08 level rework) to the current short lists. Idempotent: current
 * values map to themselves; unknown or missing values get the add-form
 * defaults. Stored records are loaded without Zod validation, so these
 * run on every load rather than as a one-time write-back.
 */
const READING_MIGRATION = {
    // legacy values
    LETTERS: 'ONE_WORD',
    SINGLE_SYLLABLE_WORD: 'ONE_WORD',
    MULTI_SYLLABLE_WORD: 'SEVERAL_WORDS',
    SENTENCE: 'SINGLE_VERSE',
    SHORT_PASSAGE: 'PASSAGE',
    LONG_PASSAGE: 'PASSAGE',
    // current values (identity)
    ONE_WORD: 'ONE_WORD',
    SEVERAL_WORDS: 'SEVERAL_WORDS',
    SINGLE_VERSE: 'SINGLE_VERSE',
    PASSAGE: 'PASSAGE',
};
const WRITING_MIGRATION = {
    // legacy values
    LETTERS: 'ONE_WORD',
    SINGLE_SYLLABLE_WORD: 'ONE_WORD',
    MULTI_SYLLABLE_WORD: 'SEVERAL_WORDS',
    SHORT_SENTENCE: 'SENTENCES',
    LONG_SENTENCE: 'SENTENCES',
    // current values (identity)
    NONE: 'NONE',
    ONE_WORD: 'ONE_WORD',
    SEVERAL_WORDS: 'SEVERAL_WORDS',
    SENTENCES: 'SENTENCES',
};
export function migrateReadingLevel(value) {
    return (value && READING_MIGRATION[value]) || 'SINGLE_VERSE';
}
export function migrateWritingLevel(value) {
    return (value && WRITING_MIGRATION[value]) || 'NONE';
}
//# sourceMappingURL=reading-level-migration.js.map